import { apiPost } from '@/lib/apiFetch';

export interface SharePointSignoffData {
  pc_sku: string;
  serial_number: string;
  windows_edition: string;
  windows_version: string;
  os_build: string;
  gpu_model: string;
  gpu_driver_version: string;
  passmark_rating: string;
  cpu_mark: string;
  graphics_2d_mark: string;
  graphics_3d_mark: string;
  memory_mark: string;
  disk_mark: string;
  branding_stickers: boolean;
  qa_seals: boolean;
  sku_sn_stickers: boolean;
  aoi_box: boolean;
  windows_license_sticker: boolean;
  date: string;
  technician: string;
  comments: string;
}

/** Posts via api/notify, which holds the flow URL - see that route for why. */
export async function postToSharePoint(data: SharePointSignoffData): Promise<boolean> {
  try {
    await apiPost('/api/notify', { kind: 'sharepoint', payload: data });
    return true;
  } catch (err) {
    console.error('SharePoint webhook failed:', err);
    return false;
  }
}
